import { formatPhoneNumber } from 'helpers/format-phone-number';
import { subLocationNameGenerator } from 'helpers/site-name-generator';
import React from 'react';

import {
  Component,
  CoreInfo,
  NameContainer,
  Name,
  LeftContainer,
  Address,
  Details,
  Detail,
} from './styles';

const SubLocationCard = ({ subLocation, setSubLocation, handleModalOpen }) => {
  const {
    address,
    city,
    state,
    country,
    room,
    postal_code: postalCode,
    contact_first_name: contactFirstName,
    contact_last_name: contactLastName,
    contact_title: contactTitle,
    contact_email: contactEmail,
    contact_phone: contactPhone,
    is_virtual: isVirtual,
  } = subLocation;

  const contactInfoAvailable =
    contactFirstName ||
    contactLastName ||
    contactTitle ||
    contactPhone ||
    contactEmail;

  const handleSetSublocation = () => {
    setSubLocation(subLocation);
    handleModalOpen();
  };

  return (
    <Component onClick={handleSetSublocation}>
      <CoreInfo contactInfoAvailable={contactInfoAvailable}>
        <LeftContainer>
          <NameContainer>
            <Name>{subLocationNameGenerator(subLocation, isVirtual)}</Name>
          </NameContainer>

          <Address>
            {isVirtual ? (
              <>{room}</>
            ) : (
              <>
                {address}, {city}, {state}, {postalCode}, {country}
              </>
            )}
          </Address>
        </LeftContainer>
      </CoreInfo>

      {(contactFirstName ||
        contactLastName ||
        contactTitle ||
        contactPhone ||
        contactEmail) && (
        <Details>
          {contactFirstName && contactLastName && (
            <Detail>
              {contactFirstName} {contactLastName}
            </Detail>
          )}
          {contactTitle && <Detail>{contactTitle}</Detail>}
          {contactPhone && <Detail>{formatPhoneNumber(contactPhone)}</Detail>}
          {contactEmail && <Detail>{contactEmail}</Detail>}
        </Details>
      )}
    </Component>
  );
};

export default SubLocationCard;
